/**
 * Maps Arabic subject names to their English equivalents for search
 */

export const arabicToEnglishSubjects: Record<string, string> = {
  // English variations
  'انجليزى': 'english',
  'انجليزي': 'english',
  'الانجليزية': 'english',
  'لغة انجليزية': 'english',
  'انقلش': 'english',
  
  // Math variations
  'رياضيات': 'math',
  'رياضه': 'math',
  'الرياضيات': 'math',
  'حساب': 'math',
  
  // Programming variations
  'برمجة': 'programming',
  'برمجه': 'programming',
  'البرمجة': 'programming',
  'كمبيوتر': 'programming',
  'حاسوب': 'programming',
  
  // Music variations
  'موسيقى': 'music',
  'موسيقي': 'music',
  'الموسيقى': 'music',
  'غناء': 'music',
  
  // Fitness variations
  'لياقة': 'fitness',
  'لياقه': 'fitness',
  'اللياقة': 'fitness',
  'رياضة': 'fitness',
  'تمارين': 'fitness',
  'جيم': 'fitness',
  
  // Travel variations
  'سفر': 'travel',
  'السفر': 'travel',
  'سياحة': 'travel',
  'رحلات': 'travel',
};

/**
 * Translates Arabic search query to English if it matches known subjects
 * @param query - The search query (can be Arabic or English)
 * @returns The English equivalent if Arabic subject is found, otherwise returns original query
 */
export const translateSearchQuery = (query: string): string => {
  if (!query) return query;
  
  const normalizedQuery = query.trim().toLowerCase();
  
  // Check if the query matches any Arabic subject name
  const englishEquivalent = arabicToEnglishSubjects[normalizedQuery];
  
  if (englishEquivalent) {
    return englishEquivalent;
  }
  
  // Check for partial matches (query contains an Arabic subject word)
  for (const [arabic, english] of Object.entries(arabicToEnglishSubjects)) {
    if (normalizedQuery.includes(arabic)) {
      return english;
    }
  }
  
  // Return original query if no Arabic subject match found
  return query;
};
